import { render, staticRenderFns } from "./orders.vue?vue&type=template&id=031b7d5c&scoped=true&"
import script from "./orders.vue?vue&type=script&lang=js&"
export * from "./orders.vue?vue&type=script&lang=js&"
import style0 from "./orders.css?vue&type=style&index=0&id=031b7d5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031b7d5c",
  null
  
)

export default component.exports